import { getAPIBaseURL } from './helpers'
import { getData, updateData, postData, deleteData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')
  return token ? { token } : {}
}

export const listAdmins = async (params = {}) => {
  const url = `${base()}/admins`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data || [] }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const getAdminById = async (adminId) => {
  const url = `${base()}/admins/${adminId}`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const createAdmin = async (adminData) => {
  const url = `${base()}/admins`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  Object.keys(adminData).forEach(key => {
    if (adminData[key] !== undefined && adminData[key] !== null && adminData[key] !== '') {
      params.append(key, adminData[key])
    }
  })
  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const updateAdmin = async (adminData) => {
  const url = `${base()}/admins`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  Object.keys(adminData).forEach(key => {
    if (adminData[key] !== undefined && adminData[key] !== null && adminData[key] !== '') {
      params.append(key, adminData[key])
    }
  })
  const res = await updateData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const updateAdminStatus = async (adminId, status) => {
  const url = `${base()}/admins/status`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  params.append('adminId', adminId)
  params.append('status', status)
  const res = await updateData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const changeAdminPassword = async (adminId, newPassword) => {
  const url = `${base()}/admins/change-password`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  params.append('adminId', adminId)
  params.append('newPassword', newPassword)
  const res = await updateData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const deleteAdmin = async (adminId) => {
  const url = `${base()}/admins`
  const headers = getAuthHeaders()
  const params = { adminId }
  const res = await deleteData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

